import * as Types from './mutation-types'
import { cloneDeep } from 'lodash'
import api from '@/modules/api'
import pluralize from 'pluralize'
import storage from '@/modules/storage'

const actions = {

  async loadApp ({ commit }) {
    if(!window.SP){
      return
    }

    commit(Types.APP_LOAD_BEGIN)

    return window.SP.Scenario.loading
      .then(() => window.SP.Scenario.User.getAccessToken())
      .then(async (token) =>  {
        commit(Types.SET_TOKEN,token)

        let SP = storage.get("SP")
        let userPermissions = []
        const schemaUpdatedAt = storage.get('SchemaCacheUpdatedAt')
        const spStateUpdatedAt =  storage.get('SPStateUpdatedAt')

        const { 
          Company:{ attributes: Company },
          Store:{ attributes: Store },
          User:{ attributes: User }
        } = window.SP.Scenario

        if(!SP || !spStateUpdatedAt || spStateUpdatedAt !== schemaUpdatedAt || SP.Store.id !== Store.id) {
          Company.EnabledModules = window.SP.Scenario.SchemaCache.attributes.companyId ?
            window.SP.Scenario.SchemaCache.attributes.data.EnabledModules : {}
  
          const userStores = window.SP.Scenario.User.getAssignedStores()
          const assignedStoreIds = userStores.map((s)=>s.attributes.storeId)

          SP = { 
            Company : cloneDeep(Company),
            Store   : { 
              ...cloneDeep(Store), 
              Employees : window.SP.Scenario.Store.getEmployees().map(e => e.toJSON())
            },
            CompanyStores    : window.SP.Scenario.Company.getStores().map(s => s.toJSON()),
            CompanyEmployees : window.SP.Scenario.Company.getEmployees().filter(e => e.isActive()).map(e => ({
              ...e.toJSON(),
              UserStores : e.getAssignedStores().map(s => s.toJSON())
            })),
  
            User : cloneDeep(User),
            assignedStoreIds
          }

          storage.set('SP', SP)
          storage.set('SPStateUpdatedAt', schemaUpdatedAt)
        }

        try {
          userPermissions = window.SP.Scenario.User.getMappedPermissions()
        } catch(e) {
          userPermissions = await api.user.fetchPermissions(SP.User.id)
        }

        commit(Types.APP_LOAD_SUCCESS,{ SP, userPermissions })
      })
      .catch((e)=> commit(Types.APP_LOAD_ERROR, e))
  },
  
  async checkLogin ({ commit }) {
    if(window.SP && window.SP.Scenario){
      return window.SP.Scenario.loading
        .then(() => window.SP.Scenario.User.getAccessToken())
        .then(async (token) =>  commit(Types.SET_TOKEN,token))
    }
    commit(Types.SET_TOKEN, null) 
  },

  mergeObject({ commit },o){
    commit(Types.APP_MERGE_OBJECT,o)
  },
  
  async companyUpdate({ commit,dispatch },{ companyId ,data }) {
    try {
      commit(Types.UPDATE_COMPANY_BEGIN)
      const response = await api.company.update(companyId,data )
      dispatch('app/mergeObject',{ key : 'Company',object : response.data },{ root : true })
      commit(Types.UPDATE_COMPANY_SUCCESS);
    } catch (e) {
      commit(Types.UPDATE_COMPANY_ERROR, e);
    }
  },
  showForm({ commit, rootState }, { id, namespace }){
    // name must be matched with one of the store module namespace
    let formData = {}

    if(id){
      formData = rootState[namespace][pluralize.plural(namespace)].find(r => r.id === id)
    }

    commit(Types.SHOW_FORM, { namespace, formData })
  }
}

export default actions
